<div
    class="agpr-agenticUpsellBanner"
    [class.expanded]="isExpanded"
    [ngClass]="{
        'agpr-agenticUpsellBanner--light': !isWhiteLabeledBrand,
        'agpr-agenticUpsellBanner--primary': isWhiteLabeledBrand
    }"
>
    <agpr-panel
        [collapsed]="true"
        (collapsedChange)="onCollapsedChange($event)"
        (afterToggle)="onAfterToggle($event)"
        [marginTop]="0"
    >
        <ng-template #panelHeader>
            <div class="agpr-agenticUpsellBanner-heading">
                <span
                    class="agpr-agenticUpsellBanner-icon fa-kit-duotone fa-agpr-ai-generic"
                    aria-hidden="true"
                ></span>
                <span>{{ heading | localize }}</span>
            </div>
        </ng-template>
        <div class="agpr-agenticUpsellBanner-content">
            <div class="agpr-agenticUpsellBanner-message">{{ message | localize }}</div>
            <div class="agpr-agenticUpsellBanner-footer">
                @if (learnMoreUrl) {
                    <agpr-button
                        [id]="id + '_learnMore'"
                        class="agpr-agenticUpsellBanner-button"
                        label="Common.agenticUpsell.learnMore"
                        [style]="buttonTypes.primaryB"
                        (click)="learnMore()"
                    ></agpr-button>
                }
                <agpr-button
                    [id]="id + '_getInTouch'"
                    class="agpr-agenticUpsellBanner-button"
                    label="Common.agenticUpsell.getInTouch"
                    ariaLabel="Common.agenticUpsell.getInTouch.ariaLabel"
                    [style]="buttonTypes.primary"
                    (click)="getInTouch()"
                ></agpr-button>
            </div>
        </div>
    </agpr-panel>
</div>
